/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.28",
    versionName: "0.2.0-nightly.2025.11.28",
    versionChannel: "nightly",
    buildDate: "2025-11-28T00:07:58.824Z",
    commitHash: "bdc596e40c41397b728c6d94586d80857ae0e14c",
};
